import React, { useEffect, useRef } from "react"
import Section from "../blocks/section"
import CConsentBanner from "../elements/c_consent_banner"

function MPodigeePlayerScript({ url }: { url: string }) {
  const playerRef = useRef(null)

  useEffect(() => {
    if (!playerRef.current) return

    const script = document.createElement("script")
    script.src = "https://player.podigee-cdn.net/podcast-player/javascripts/podigee-podcast-player.js"
    script.className = "podigee-podcast-player"
    script.setAttribute("data-configuration", url)

    playerRef.current.appendChild(script)
  }, [url])

  return <div ref={playerRef}></div>
}

function MPodigeePlayer({ data }: { data: { path_segment: string } & Record<string, any> }) {
  return (
    <Section data={data} defaultPadding="small">
      {/*// @ts-ignore*/}
      <CConsentBanner serviceName="Podigee">
        <div className="u-Wrapper">
          <div className="u-Container">
            <div className="u-Content">
              <MPodigeePlayerScript url={data.path_segment} />
            </div>
          </div>
        </div>
      </CConsentBanner>
    </Section>
  )
}

export default MPodigeePlayer